export const getImpactDetailedRows = state => (
    state.impactAnalysis.impactDetailed.impactDetailedRows.length
);

export const getPricingParametersLoaded = state => (
    state.impactAnalysis.pricingParameters.pricingParametersInfoLoaded
);

export const getImpactSummaryLoaded = state => (
    state.impactAnalysis.impactSummary.impactSummaryLoaded
);

export const getImpactDetailedLoaded = state => (
    state.impactAnalysis.impactDetailed.impactDetailedDataLoaded
);
